import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { ArrowRightIcon, WindIcon, EyeIcon, MessageCircleIcon } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    id: 1,
    title: 'Cuerpo',
    desc: 'Bajas el volumen (respiración + descarga de tensión)',
    icon: WindIcon,
    color: 'bg-teal/10 text-teal'
  }, {
    id: 2,
    title: 'Contexto',
    desc: 'Cambias señales (sensorial: presión, temperatura, sonido, luz)',
    icon: EyeIcon,
    color: 'bg-navy/10 text-navy'
  }, {
    id: 3,
    title: 'Cabeza',
    desc: 'Cierras con un guion simple para que tu mente no rebote',
    icon: MessageCircleIcon,
    color: 'bg-orange-100 text-orange-600'
  }];
  return <Section id="solution" background="warm" data-id="element-185">
      <div className="text-center mb-16" data-id="element-186">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-187">
          Lo que cambia todo: el orden correcto
        </h2>
        <p className="text-xl text-gray-600" data-id="element-188">
          Protocolo 3C: Cuerpo → Contexto → Cabeza
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-189">
        {steps.map((step, index) => <motion.div key={step.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} className="bg-white p-8 rounded-2xl shadow-sm border border-warm-gray hover:shadow-md transition-shadow" data-id="element-190">
            <div className={`w-12 h-12 rounded-full ${step.color} flex items-center justify-center mb-6`} data-id="element-191">
              <step.icon className="h-6 w-6" data-id="element-192" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-193">
              {step.id}. {step.title}
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-194">{step.desc}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-navy text-white rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-195">
        <div className="relative z-10" data-id="element-196">
          <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-197">
            No es espiritual. No es clínico. Es práctico.
          </h3>
          <p className="text-xl mb-8 text-white/90" data-id="element-198">
            Y se puede hacer en{' '}
            <span className="font-bold text-teal underline decoration-2 underline-offset-4" data-id="element-199">
              10 minutos
            </span>
            .
          </p>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 md:p-8 max-w-2xl mx-auto border border-white/20" data-id="element-200">
            <h4 className="text-xl font-semibold mb-4 text-teal-light" data-id="element-201">
              Presentando:
            </h4>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif tracking-wide" data-id="element-202">
              El Reset de 10 Minutos para tu Sistema Nervioso
            </h2>
            <img src="https://cdn.magicpatterns.com/uploads/pnmLnCBDvUJF6XXtrV8i5k/heylloyd-image-RESET_10_MIN.png" alt="El Reset de 10 Minutos para tu Sistema Nervioso" className="w-full max-w-xs mx-auto rounded-xl shadow-lg mb-6" data-id="element-203" />
            <p className="text-lg text-white/80 mb-0" data-id="element-204">
              Un e-book corto, directo y accionable, diseñado para
              hispanohablantes en EE. UU. con poco tiempo, mucho estrés y una
              vida que no se puede pausar.
            </p>
          </div>
        </div>

        {/* Decorative circles */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-teal/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-205" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-teal/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-206" />
      </motion.div>
    </Section>;
}